





































    
import {Vue, Component, Prop} from 'vue-property-decorator';
import { ClientProjectTask } from '../../../../services/accounting.service';

@Component({})
export default class ClientProjectsList extends Vue {
    @Prop()
    public tasks!: ClientProjectTask[];
}

